/**
 * AdrProfile — Architecture Decision Records as graphs.
 * See plans/software-design/domain.md § 11.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type AdrNodeType = 'adr_decision' | 'adr_option' | 'adr_consequence';
export type AdrEdgeType = 'adr_led_to' | 'adr_supersedes';

export const AdrProfile: DomainDataProfile<AdrNodeType, AdrEdgeType> = {
  domainId: 'adr',
  profileVersion: '1.0',
  diagramTypes: ['generic' as DiagramType],
  nodeTypes: ['adr_decision', 'adr_option', 'adr_consequence'],
  edgeTypes: ['adr_led_to', 'adr_supersedes'],
  vocabulary: {
    recordSingular: 'Decision',
    recordPlural: 'Decisions',
    repositoryLabel: 'Decision Log',
    hierarchyLabel: 'Supersedes',
    importAction: 'Import ADRs',
    keyColumnHint: 'Decision',
    commitLabel: 'Push ADR',
    pullLabel: 'Refresh ADR',
    diagramLabel: 'ADR graph',
  },
  fieldAliases: {
    name: ['title', 'decision'],
    status: ['state'],
  },
  requiredProps: ['name', 'status'],
  recommendedProps: ['options', 'consequences'],
  primaryShapeType: 'adr_decision',
  propsToAttrsMapping: {
    name: 'name',
    status: 'status', // proposed | accepted | deprecated | superseded
    date: 'date',
    options: 'options',
    consequences: 'consequences',
  },
  relationshipPackId: 'software-design-relationships',
};
